(function($, duo, undefined) {

	"use strict";

	/**
	 * @class Navigation
	 * There should only be one "Navigation" on the website
	 */
	class Navigation {

		/**
		 * Creates an instance of Navigation
		 * @param {string} navSelector css selector for the Navigation element
		 * @param {string} toggleButtonRole value of a data-role attribute for menu toggle buttons
		 * @param {string} openClass css class name used on the classHolder when the Navigation is open
		 * @param {string} classHolder css selector for the element that will contain the toggle class
		 * @param {bool} useTransitions set to "true" if the Navigation uses transitions to open and close
		 */
		constructor({navSelector = '#main-nav', toggleButtonRole = 'main-nav-toggle', openClass = 'js-sitenav-visible', classHolder = 'html', useTransitions = true} = {}) {
			this.navSelector = navSelector;
			this.element = $(navSelector);

			this.toggleButtonRole = toggleButtonRole;
			this.openClass = openClass;
			this.classHolder = $(classHolder);
			this.useTransitions = useTransitions;

			this.currentMenuTogglerElement = null;

			// focus helper:
			this.keyboardTrap = new duo.KeyboardTrap(navSelector);

			// setup event handlers:
			this._setEventHandlers();
		} /* constructor */

		/**
		 * Getter - returns Navigation visibility
		 * @returns {bool} a boolean to indicate whether the Navigation is visible
		 */
		get isVisible() {
			return this.classHolder.hasClass(this.openClass);
		} /* isVisible */

		/**
		 * Show the Navigation
		 */
		show($senderButton) {
			const navigation = this;

			// save the sender-button:
			navigation.currentMenuTogglerElement = $senderButton;

			// add "animated" class:
			navigation.element.addClass('animated');

			// add the openClass:
			navigation.classHolder.addClass(this.openClass);

			// enable keyboard-trap:
			if(!navigation.useTransitions) {
				navigation.keyboardTrap.trap();
			}

			// page focus listener:
			// -> attach a listener to redirect the tab to the Navigation if the user somehow gets out of it:
			$('body').on('focusin.Navigation', function() {
				if(document.activeElement) {
					if($(document.activeElement).parents(`${navigation.navSelector}`).length === 0) {
						navigation.keyboardTrap.trap();
					}
				}
			});

		} /* show */

		/**
		 * Hide the Navigation
		 */
		hide() {
			// remove the openClass:
			this.classHolder.removeClass(this.openClass);

			// remove page focus listener:
			$('body').off('focusin.Navigation');
			$('body').removeClass('show-mobile-menu-language show-mobile-user-menu show-mobile-mega-menu');

			// stop keyboard-trap:
			this.keyboardTrap.unTrap();
			if(this.currentMenuTogglerElement !== null) {
				this.currentMenuTogglerElement.focus();
			}

		} /* hide */

		/**
		 * Toggle the Navigation
		 */
		toggle($senderButton) {
			if(this.isVisible) {
				this.hide();
			} else {
				this.show($senderButton);
			}
		} /* toggle */

		_setEventHandlers() {
			const navigation = this;

			// mainnav toggle-button:
			$(document).on('click', `[data-role=${navigation.toggleButtonRole}]`, function(event) {
				event.preventDefault();
				navigation.toggle($(this));
			});

			// close the mainnav by clicking somewhere on the page:
			$(document).on('click touchstart', function(event) {
				if(navigation.isVisible) {
					const target = $(event.target);
					if(target.closest(navigation.navSelector).length <= 0 && target.closest(`[data-role=${navigation.toggleButtonRole}]`).length <= 0) {
						navigation.hide();					}
				}
			});

			// close the mainnav with the keyboard (ESC-key):
			$(document).on('keydown.mainnav', function(e) {
				if(e.keyCode === 27) {
					if(navigation.isVisible) {
						navigation.hide();
					}
				}
			});

			// transition-end event:
			// -> note: this event fires for every property that transitions
			if(navigation.useTransitions) {
				navigation.element.on(duo.Utils.transitionEvent, function(event) {
					if(event.target === navigation.element[0]) {
						if(navigation.isVisible) {
							if(!navigation.keyboardTrap.isActive) {
								navigation.keyboardTrap.trap();
							}
						} else {
							// -> remove the element transition, because we don't
							//    want to have it when resizing the browser window:
							navigation.element.removeClass('animated');
						}
					}
				});
			}

			//  window resize event:
			// -> disable the keyboard trap if the window is resized
			//    (just in case the user gets trapped for some reason)
			var navResizeTimer;
			$(window).on('resize.Navigation', function(event) {
				clearTimeout(navResizeTimer);
				navResizeTimer = setTimeout(function() {
					if(navigation.keyboardTrap.isActive) {
						navigation.keyboardTrap.unTrap();
					}
				}, 100);
			});
		} /* _setEventHandlers */
	
	} /* Navigation */

	duo.Navigation = Navigation;

})(jQuery, window.duo = window.duo || {});
